<template>
  <div class="structured-inner-wrapper">
    <p v-html="info" />
    <Checkbox
      label-class="mb-0 mt-0"
      v-model="wantsNewsletter"
      name="wantsNewsletter"
    >
      <span v-html="labelCheckbox" />
    </Checkbox>

    <BCollapse id="newsletter" v-model="wantsNewsletter" class="row">
      <ValidationField
        email
        highlight
        :required="wantsNewsletter"
        :disabled="!wantsNewsletter"
        :value="subscriptionEmail"
        class="mt-3 col-12 col-md-6"
      >
        <template v-slot:default>
          <label for="newsletter-email">
            <span class="marker step-by-step">*</span>
            {{ $t('newsletter.subscriptionEmail') }}
          </label>
          <input
            id="newsletter-email"
            type="email"
            class="form-control"
            v-model="subscriptionEmail"
            :disabled="!wantsNewsletter"
          >
        </template>
        <template v-slot:error>
          <slot name="validationFeedback" />
        </template>
      </ValidationField>
    </BCollapse>
  </div>
</template>

<script>
import Checkbox from './Checkbox';
import ValidationField from './ValidationField';
import { BCollapse } from 'bootstrap-vue-next';

export default {
  props: ['info', 'labelCheckbox'],
  components: {
    BCollapse,
    Checkbox,
    ValidationField,
  },
  data: () => ({
    wantsNewsletter: false,
    subscriptionEmail: '',
  }),
  watch: {
    $data: {
      deep: true,
      handler() {
        if (!this.wantsNewsletter) {
          const event = { ...this.$data, subscriptionEmail: '' };
          this.$emit('change', event);
        } else {
          this.$emit('change', this.$data);
        }
      },
    },
  },
};
</script>
